import React, { useEffect, useState } from 'react';
import styles from './LeftSide.module.scss'; // Make sure to create this SCSS module
import { CheckCircleFill } from 'react-bootstrap-icons';
import W3LogoButton from '../../SharedLib/Component/Buttons/W3LogoButton/W3LogoButton';
import {
  getClassroomInvitationBrowserStorageMeta,
  IClassroomInvitationBrowserStorageMeta,
} from '../ClassroomInvitation/ClassroomInvitationUtil';
import { Lynx } from './lynx';

const LeftSide: React.FC = () => {
  const [classroomInvitationIsSet, setClassroomInvitationIsSet] = useState<boolean>(false);
  const [classroomInvitation, setClassroomInvitation] = useState<IClassroomInvitationBrowserStorageMeta>(
    {} as IClassroomInvitationBrowserStorageMeta,
  );

  useEffect(() => {
    const _classroomInvitation = getClassroomInvitationBrowserStorageMeta();
    const _classroomInvitationIsSet = _classroomInvitation !== null;

    if (_classroomInvitationIsSet) {
      setClassroomInvitation(_classroomInvitation);
    }

    setClassroomInvitationIsSet(_classroomInvitationIsSet);
  }, []);

  const LeftSideClassroom = () => {
    return (
      <div className={styles.classroom_invitation}>
        <h1 className={styles.academyTitle}>
          {classroomInvitation.details.invitedMember.canRegister ? (
            <>
              Register your account to join "{classroomInvitation.details.groupName}" classroom{' '}
              <span className={styles.academy}>at {classroomInvitation.details.organizationName}</span>
            </>
          ) : (
            <>
              Log in to your account to accept the invitation{' '}
              <span className={styles.academy}>from {classroomInvitation.details.organizationName}</span>
            </>
          )}
        </h1>
      </div>
    );
  };

  const HorizontalFeatureList = () => {
    return (
      <ul className={styles.featuresList}>
        <li>
          <div className={styles.checkIconContainer}>
            <CheckCircleFill className={styles.checkIcon} color="#04AA6D" />{' '}
          </div>
          <span>Track your progress</span>
        </li>
        <li>
          <div className={styles.checkIconContainer}>
            <CheckCircleFill className={styles.checkIcon} color="#04AA6D" />{' '}
          </div>
          <span>Ad-free learning</span>
        </li>
        <li>
          <div className={styles.checkIconContainer}>
            <CheckCircleFill className={styles.checkIcon} color="#04AA6D" />{' '}
          </div>
          <span>Build and host websites</span>
        </li>
      </ul>
    );
  };

  const Heading = () => {
    return (
      <div className={styles.heading}>
        <h1 className={styles.title}>Enjoy a free trial</h1>
        <h1 className={styles.title}>of the Hero plan 💚</h1>
      </div>
    );
  };

  const FeaturesText = () => {
    return (
      <div className={styles.features_text}>
        Get access to all Hero plan features such as a Dashboard, Progress Tracking, Assessments, Build and host websites, Code Challenges,
        and much more. Your plan can be changed at any time.
      </div>
    );
  };

  return (
    <div className={styles.leftSideContainer}>
      <div className={styles.header_logo}>
        <W3LogoButton loggedIn={false} width="69" height="65" />
      </div>
      <div className={styles.content}>
        {classroomInvitationIsSet && <LeftSideClassroom />}
        <HorizontalFeatureList />
        <Heading />
        <FeaturesText />
        <Lynx />
      </div>
    </div>
  );
};

export default LeftSide;
